import type { AccountNumber, ImmediatePaymentInfo, OcrInformation } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

export const SERVICE_PATH = 'rest/resource/ocr';

export const fetchOcrInformation = (accountNumber: AccountNumber): Promise<OcrInformation> => {
    return get<OcrInformation>(`${CONTEXT_PATH}/${SERVICE_PATH}/${accountNumber.value}`);
};

export const fetchImmediatePaymentInfoForCreditor = async (
    creditorAccountNumber: AccountNumber,
    debitorAccountNumber: AccountNumber,
) => {
    const queryString = `?creditorAccountNumber=${creditorAccountNumber.value}&debitorAccountNumber=${debitorAccountNumber.value}`;
    return get<ImmediatePaymentInfo>(`${CONTEXT_PATH}/${SERVICE_PATH}/immediate${queryString}`);
};
